exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hide-ok-button .ant-modal-footer .ant-btn.ant-btn-primary {\n  display: none;\n}\n.hide-ok-button .ant-modal-footer .ant-btn.ant-btn-default {\n  margin: 0;\n}\n", ""]);

// exports
